import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProtocolosService {

  httpOptions: any;
  customerId: any;
  storage: Storage;
  token: any;

  private translationMap: { [key: string]: string } = {
    'Área de Preservação Permanente': 'areaPreservacaoPermanente',
    'Terras Indígenas': 'indigenousLands',
    'Trabalho Escravo': 'slavery',
    'Embargo Ibama': 'ibamaEmbargo',
    'Embargo Ibama Lista': 'ibamaEmbargoByProducer',
    'Deter': 'deter',
    'Solo Exposto': 'soloExposto',
    'Vigor de Pastagem': 'vigorPastagem',
    'Data do Plantio': 'dataPlantio',
    'Histórico de Focos de Queimadas': 'historicoFocosQueimadas',
    'Prodes Amazônia': 'prodesAmazon',
    'Prodes Mata Atlântica': 'prodesAtlanticForest',
    'Prodes Caatinga': 'prodesCaatinga',
    'Prodes Cerrado': 'prodesCerrado',
    'Prodes Pampa': 'prodesPampa',
    'Prodes Pantanal': 'prodesPantanal',
    'Áreas Quilombolas': 'quilombolaAreas',
    'Terra Indígena': 'indigenousLand',
    'Unidade de Conservação': 'conservationUnit',
    'Sítios Arqueológicos': 'archeologicalSites',
    'Florestas públicas': 'publicForests',
    'Áreas de mineração': 'miningAreas',
    'Alerta de Queimadas': 'burned',
    'LDI Pará': 'ldi',
    'ICMBio': 'icmBio',
    'Iterpa Peas': 'iterpaPeas',
    'Iterpa Peax': 'iterpaPeax',
    'Iterpa Glebas': 'iterpaGlebas',
    'Iterpa Quilombos': 'iterpaQuilombos',
    'Map Biomas': 'mapBiomas',
    'Alerta Map Biomas': 'mapBiomasWarning',
    'Empresas Cadastradas no CEIS': 'ceis',
    'CND DataPrev': 'cndDataprev',
    'Certidão de Débitos Relativos a Créditos Tributários': 'cdrct',
    'Entidades Privadas sem Fins Lucrativos Impedidas (CEPIM)': 'cepim',
    'CND FGTS': 'cndFgts',
    'CND Criminal': 'cndCriminal',
    'CND Trabalhista': 'cndTrabalhista',
    'Distribuição Criminal': 'distribuicaoCriminal',
    'Vegetação': 'vegetacao',
    'RenovaBio': 'renovaBio',
    'Bioma': 'bioma',
    'Área': 'area',
    'Soja': 'areaProdutiva',
    'Status': 'status',
    'Certificado de Regularidade do FGTS': 'crfgts',
    'CNEP - Cadastro Nacional de Empresas Punidas': 'cnep',
    'Certidão Negativa de Débitos Trabalhistas': 'cndt',
    'Verificação status empresa': 'company',
    'LAR Pará': 'LAR',
    'Embargo Siga': 'Embargo SIGA',
    'Embargo Sema': 'Embargo Sema',
    'Embargo Sema Lista': 'embargoSemaLista',
    'Alertas de Desmatamento Integrados': 'alertasDeDesmatamentoIntegrados',
    'Alertas de Desmatamento RADD': 'alertasDeDesmatamentoRadd',
    'Perda de Cobertura Arbórea': 'perdaDeCoberturaArborea',
    'Corpos Hídricos (Argentina)': 'corpoHidricoArgentina',
    'Terras Indígenas (Argentina)': 'terrasIndigenasArgentina',
    'Sítios Ramsar (Argentina)': 'ramsarArgentina',
    'OTBN (Ordenamento Territorial de Bosques Nativos - Argentina)': 'otbnArgentina',
    'Vegetação Nativa (Argentina)': 'vegetacaoNativaArgentina',
    'IBAs - Áreas Importantes para Aves (Argentina)': 'ibasArgentina',
    'Áreas de Alta Biodiversidade (Argentina)': 'altaBiodiversidadeArgentina',
    'Centroide': 'centroide',
    'Reserva Legal': 'legalReserve',
    'ICMBio Lista': 'icmBioLista',
    'Embargo ICMBio': 'icmBio'
  };

  public getTranslationMap(): { [key: string]: string } {
    return this.translationMap;
  }

  constructor(private http: HttpClient) {
    this.storage = window.sessionStorage;

    const item = this.storage.getItem('token');
    this.token = item ? JSON.parse(item) : {};

    const itemUser = this.storage.getItem('user');
    const user = itemUser ? JSON.parse(itemUser) : {};
    this.customerId = user.customerId;
  }

  translateCriteria(input: string): string {
    if (this.translationMap[input]) {
      return this.translationMap[input];
    }

    const reversedMap = Object.keys(this.translationMap).reduce((acc, key) => {
      acc[this.translationMap[key]] = key;
      return acc;
    }, {} as { [key: string]: string });

    return reversedMap[input] || input;
  }

  getAllCriteriasNamesReturneds() {
    return [
      'burned',
      'slavery',
      'ibamaEmbargo',
      'historicoFocosQueimadas',
      'deterAmazon',
      'deterCerrado',
      'deterPantanal',
      'prodesAmazon',
      'prodesAtlanticForest',
      'prodesCaatinga',
      'prodesCerrado',
      'prodesPampa',
      'prodesPantanal',
      'publicForests',
      'quilombolaAreas',
      'indigenousLand',
      'conservationUnit',
      'archeologicalSites',
      'miningAreas',
      'ldiManual',
      'ldiAutomatic',
      'icmBio',
      'iterpaPeas',
      'iterpaPeax',
      'iterpaGlebas',
      'iterpaQuilombos',
      'ceis',
      'cndFgts',
      'cndCriminal',
      'cndTrabalhista',
      'distribuicaoCriminal',
      'mapBiomasWarning',
      'icmBio',
      'icmBioEmbargo',
      'icmBioInfraction',
      'ibamaEmbargoByProducer',
      'crfgts',
      'cnep',
      'cndt',
      'company',
      'archeologicalSitesArea',
      'ceaf',
      'leniencyAgreements',
      'cdrcTributario',
      'cndDataprev',
      'cnpj',
      'cepim',
      'lar',
      'semaEmbargo',
      'sigaEmbargo',
      'EMBARGO SEMA',
      'EMBARGO SIGA',
      'legalReserve',
      'embargoSemaLista',
      'IcmBioLista',
      'icmBioLista',
      'soloExposto',
      'vigorPastagem',
      'dataPlantio'
    ];
  }

  getAllLayersMapName(): any {
    const layersName = [
      { name: 'icmBio', description: 'ICMBio' },
      { name: 'icmbio', description: 'ICMBio' },
      { name: 'icmBioEmbargo', description: 'ICMBio' },
      { name: 'icmBioInfractions', description: 'Infrações ICMBio' },
      { name: 'Iterpa Peas', description: 'iterpaPeas' },
      { name: 'Iterpa Peax', description: 'iterpaPeax' },
      { name: 'Iterpa Glebas', description: 'iterpaGlebas' },
      { name: 'Iterpa Quilombos', description: 'iterpaQuilombos' },
      /* { name: 'icmBioEmbargoByProducer', description: 'Embargo ICMBio por Produtor' },
       { name: 'icmBioInfractionByProducer', description: 'Infrações ICMBio por Produtor' },*/
      { name: 'archeologicalSitesArea', description: 'Sítios Arqueológicos Área' },
      { name: 'conservationUnit', description: 'UC' },
      { name: 'kml', description: 'KML' },
      { name: 'ldiAutomatic', description: 'LDI Automatizado' },
      { name: 'ldiManual', description: 'LDI Manual' },
      { name: 'deterAmazon', description: 'Deter Amazônia' },
      { name: 'deterCerrado', description: 'Deter Cerrado' },
      { name: 'deterPantanal', description: 'Deter Pantanal' },
      { name: 'ibamaEmbargo', description: 'Embargo do IBAMA' },
      { name: 'ibamaEmbargoByProducer', description: 'Embargo Ibama Lista' },
      { name: 'soloExposto', description: 'Solo Exposto' },
      { name: 'vigorPastagem', description: 'Vigor Pastagem' },
      { name: 'dataPlantio', description: 'Data do Plantio' },
      { name: 'historicoFocosQueimadas', description: 'Histórico de Focos de Queimadas' },
      { name: 'crfgts', description: 'Certificado de Regularidade do FGTS' },
      { name: 'cnep', description: 'CNEP - Cadastro Nacional de Empresas Punidas' },
      { name: 'cndt', description: 'Certidão Negativa de Débitos Trabalhistas' },
      { name: 'cepim', description: 'Entidades Privadas sem Fins Lucrativos Impedidas (CEPIM)' },
      { name: 'cndDataprev', description: 'CND DataPrev' },
      { name: 'cdrct', description: 'Certidão de Débitos Relativos a Créditos Tributários' },
      { name: 'company', description: 'Verificação status empresa' },
      { name: 'indigenousLand', description: 'Terra indígena' },
      { name: 'prodesAmazon', description: 'Prodes Amazônia' },
      { name: 'prodesAtlanticForest', description: 'Prodes Mata Atlântica' },
      { name: 'prodesCaatinga', description: 'Prodes Caatinga' },
      { name: 'prodesCerrado', description: 'Prodes Cerrado' },
      { name: 'prodesPampa', description: 'Prodes Pampa' },
      { name: 'prodesPantanal', description: 'Prodes Pantanal' },
      { name: 'publicForests', description: 'Florestas públicas' },
      { name: 'quilombolaAreas', description: 'Áreas quilombolas' },
      { name: 'property', description: 'Limite do imóvel' },
      { name: 'editing', description: '⁠Polígonos de interesse' },
      { name: 'vegetacao_MT', description: 'Vegetação' },
      { name: 'vegetacao_PR', description: 'Vegetação' },
      { name: 'vegetacao_RS', description: 'Vegetação' },
      { name: 'soja_MT', description: 'Soja' },
      { name: 'soja_PR', description: 'Soja' },
      { name: 'soja_RS', description: 'Soja' },
      { name: 'renovaBio', description: 'RenovaBio' },
      { name: 'mapBiomasWarning', description: 'Alerta Map Biomas' },
      { name: 'miningAreas', description: 'Área de mineração' },
      { name: 'EMBARGO SEMA', description: 'Embargo Sema' },
      { name: 'EMBARGO SIGA', description: 'Embargo Siga' },
      { name: 'embargoSemaLista', description: 'Embargo Sema Lista' },
      { name: 'IcmBioLista', description: 'ICMBio Lista' },
      { name: 'LAR', description: 'LAR Pará' },
      { name: 'alertasDeDesmatamentoIntegrados', description: 'Alertas de Desmatamento Integrados' },
      { name: 'alertasDeDesmatamentoRadd', description: 'Alertas de Desmatamento RADD' },
      { name: 'perdaDeCoberturaArborea', description: 'Perda de Cobertura Arbórea' },
      { name: 'corpoHidricoArgentina', description: 'Corpos Hídricos (Argentina)' },
      { name: 'terrasIndigenasArgentina', description: 'Terras Indígenas (Argentina)' },
      { name: 'ramsarArgentina', description: 'Sítios Ramsar (Argentina)' },
      { name: 'otbnArgentina', description: 'OTBN (Ordenamento Territorial de Bosques Nativos - Argentina)' },
      { name: 'vegetacaoNativaArgentina', description: 'Vegetação Nativa (Argentina)' },
      { name: 'ibasArgentina', description: 'IBAs - Áreas Importantes para Aves (Argentina)' },
      { name: 'altaBiodiversidadeArgentina', description: 'Áreas de Alta Biodiversidade (Argentina)' },
      { name: 'centroide', description: 'Centroide' },
      { name: 'Reserva Legal', description: 'legalReserve' },
      { name: 'icmBioLista', description: 'ICMBio Lista' },
    ];
    return layersName;
  }

  getLegendColor(layerName: string): string {
    switch (layerName) {
      case 'archeologicalSitesArea':
        return 'pink';
      case 'conservationUnit':
        return '#006400';
      case 'kml':
        return 'white';
      case 'deterAmazon':
        return 'orange';
      case 'deterCerrado':
        return 'orange';
      case 'deterPantanal':
        return 'orange';
      case 'ibamaEmbargo':
        return 'purple';
      case 'ibamaEmbargoByProducer':
        return 'purple';
      case 'cnep':
        return 'purple';
      case 'crfgts':
        return 'purple';
      case 'cndt':
        return 'purple';
      case 'company':
        return 'purple';
      case 'indigenousLand':
        return 'brown';
      case 'prodesAmazon':
        return 'yellow';
      case 'prodesAtlanticForest':
        return 'yellow';
      case 'prodesCaatinga':
        return 'yellow';
      case 'prodesCerrado':
        return 'yellow';
      case 'prodesPampa':
        return 'yellow';
      case 'prodesPantanal':
        return 'yellow';
      case 'quilombolaAreas':
        return 'gray';
      case 'property':
        return 'blue';
      case 'editing':
        return 'black';
      case 'mapBiomasWarning':
        return 'red';
      case 'vegetacao_MT':
        return 'green';
      case 'vegetacao_PR':
        return 'green';
      case 'vegetacao_RS':
        return 'green';
      case 'soja_MT':
        return '#CCCC66';
      case 'soja_PR':
        return '#CCCC66';
      case 'soja_RS':
        return '#CCCC66';
      case 'renovaBio':
        return '#CCFFCC';
      case 'miningAreas':
        return '#BDB76B';
      case 'publicForests':
        return '#556B2F';
      case 'burned':
        return '#FF6347';
      case 'ldiAutomatic':
        return '#4682B4';
      case 'ldiManual':
        return '#DAA520';
      case 'icmBio':
        return '#F0E68C';
      case 'icmBioEmbargo':
        return '#FF1493';
      case 'icmBioInfractions':
        return '#4B0082';
      case 'icmBioEmbargoByProducer':
        return '#32CD32';
      case 'icmBioInfractionByProducer':
        return '#FF8C00';
      case 'mapBiomas_Floresta':
        return '#1f8d49';
      case 'mapBiomas_Formação Florestal':
        return '#1f8d49';
      case 'mapBiomas_Formação Savânica':
        return '#7dc975';
      case 'mapBiomas_Mangue':
        return '#04381d';
      case 'mapBiomas_Floresta Alagável':
        return '#026975';
      case 'mapBiomas_Restinga Arbórea':
        return '#02d659';
      case 'mapBiomas_Vegetação Herbácea e Arbustiva':
        return '#ad975a';
      case 'mapBiomas_Campo Alagado e Área Pantanosa':
        return '#519799';
      case 'mapBiomas_Formação Campestre':
        return '#d6bc74';
      case 'mapBiomas_Apicum':
        return '#fc8114';
      case 'mapBiomas_Afloramento Rochoso':
        return '#ffaa5f';
      case 'mapBiomas_Restinga Herbácea':
        return '#ad5100';
      case 'mapBiomas_Agropecuária':
        return '#FFFFB2';
      case 'mapBiomas_Pastagem':
        return '#edde8e';
      case 'mapBiomas_Agricultura':
        return '#E974ED';
      case 'mapBiomas_Lavoura Temporária':
        return '#c27ba0';
      case 'mapBiomas_Soja':
        return '#f5b3c8';
      case 'mapBiomas_Cana':
        return '#db7093';
      case 'mapBiomas_Arroz':
        return '#c71585';
      case 'mapBiomas_Algodão':
        return '#ff69b4';
      case 'mapBiomas_Outras Lavouras Temporárias':
        return '#f54ca9';
      case 'mapBiomas_Lavoura Perene':
        return '#d082de';
      case 'mapBiomas_Café':
        return '#d68fe2';
      case 'mapBiomas_Citrus':
        return '#9932cc';
      case 'mapBiomas_Dendê':
        return '#9065d0';
      case 'mapBiomas_Outras Lavouras Perenes':
        return '#e6ccff';
      case 'mapBiomas_Silvicultura':
        return '#7a5900';
      case 'mapBiomas_Mosaico de Usos':
        return '#ffefc3';
      case 'mapBiomas_Área não Vegetada':
        return '#d4271e';
      case 'mapBiomas_Praia, Duna e Areal':
        return '#ffa07a';
      case 'mapBiomas_Área Urbanizada':
        return '#d4271e';
      case 'mapBiomas_Mineração':
        return '#9c0027';
      case 'mapBiomas_Outras Áreas não Vegetadas':
        return '#db4d4f';
      case 'mapBiomas_Corpo D\'água':
        return '#0000FF';
      case 'mapBiomas_Rio, Lago e Oceano':
        return '#2532e4';
      case 'mapBiomas_Aquicultura':
        return '#091077';
      case 'mapBiomas_Não Observado':
        return '#ffffff';

      default:
        return 'white';
    }
  }

  getCriteriaReturnedName(type: string): string {
    let result: string;

    switch (type) {
      case 'areaPreservacaoPermanente':
        result = 'Área de Preservação Permanente'
        break;
      case 'indigenousLands':
        result = 'Terras Indígenas'
        break;
      case 'cepim':
        result = 'Entidades Privadas sem Fins Lucrativos Impedidas (CEPIM)';
        break;
      case 'historicoFocosQueimadas':
        result = 'Histórico de Focos de Queimadas';
        break;
      case 'cndDataprev':
        result = 'CND DataPrev';
        break;
      case 'cdrct':
        result = 'Certidão de Débitos Relativos a Créditos Tributários';
        break;
      case 'burned':
        result = 'Alerta de Queimadas';
        break;
      case 'mapBiomasWarning':
        result = 'Alerta Map Biomas';
        break;
      case 'mapBiomas':
        result = 'Map Biomas';
        break;
      case 'archeologicalSites':
        result = 'Sitios Arqueológicos';
        break;
      case 'archaeologicalSites':
        result = 'Sitios Arqueológicos';
        break;
      case 'archeologicalSitesArea':
        result = 'Sitios Arqueológicos Área';
        break;
      case 'property':
        result = 'Propriedade';
        break;
      case 'editing':
        result = 'Area resumida';
        break;
      case 'conservationUnit':
        result = 'Unidade de Conservação';
        break;
      case 'deter':
        result = 'Deter';
        break;
      case 'deterAmazon':
        result = 'Deter Amazônia';
        break;
      case 'deterCerrado':
        result = 'Deter Cerrado';
        break;
      case 'dataPlantio':
        result = 'Data do Plantio';
        break;
      case 'vigorPastagem':
        result = 'Vigor de Pastagem';
        break;
      case 'soloExposto':
        result = 'Solo Exposto';
        break;
      case 'deterPantanal':
        result = 'Deter Pantanal';
        break;
      case 'ibamaEmbargo':
        result = 'Embargo Ibama';
        break;
      case 'ibamaEmbargoByProducer':
        result = 'Embargo Ibama Lista';
        break;
      case 'iterpaPeas':
        result = 'Iterpa Peas';
        break;
      case 'iterpaPeax':
        result = 'Iterpa Peax';
        break;
      case 'iterpaGlebas':
        result = 'Iterpa Glebas';
        break;
      case 'iterpaQuilombos':
        result = 'Iterpa Quilombos';
        break;
      case 'crfgts':
        result = 'Certificado de Regularidade do FGTS';
        break;
      case 'cnep':
        result = 'CNEP - Cadastro Nacional de Empresas Punidas';
        break;
      case 'indigenousLand':
        result = 'Terra Indígena';
        break;
      case 'prodesAmazon':
        result = 'Prodes Amazônia';
        break;
      case 'prodesAtlanticForest':
        result = 'Prodes Mata Atlântica';
        break;
      case 'prodesCaatinga':
        result = 'Prodes Caatinga';
        break;
      case 'prodesCerrado':
        result = 'Prodes Cerrado';
        break;
      case 'prodesPampa':
        result = 'Prodes Pampa';
        break;
      case 'prodesPantanal':
        result = 'Prodes Pantanal';
        break;
      case 'publicForests':
        result = 'Florestas Públicas';
        break;
      case 'quilombolaAreas':
        result = 'Áreas Quilombolas';
        break;
      case 'slavery':
        result = 'Trabalho Escravo';
        break;
      case 'miningAreas':
        result = 'Área de Mineração';
        break;
      case 'ldiAutomatic':
        result = 'LDI Automatizado';
        break;
      case 'ldiManual':
        result = 'LDI Manual';
        break;
      case 'ldi':
        result = 'LDI';
        break;
      case 'icmBio':
        result = 'ICMBio';
        break;
      case 'Embargo ICMBio':
        result = 'Embargo ICMBio';
        break;
      case 'icmbio':
        result = 'ICMBio';
        break;
      case 'cndCriminal':
        result = 'CND Criminal';
        break;
      case 'ceis':
        result = 'Empresas Cadastradas no CEIS';
        break;
      case 'cndFgts':
        result = 'CND FGTS';
        break;
      case 'cndTrabalhista':
        result = 'CND Trabalhista';
        break;
      case 'icmBioInfraction':
        result = 'Auto de Infrações ICMBio';
        break;
      case 'distribuicaoCriminal':
        result = 'Distribuição Criminal';
        break;
      case 'vegetacao':
      case 'vegetacao_MT':
      case 'vegetacao_PR':
      case 'vegetacao_RS':
        result = 'Vegetação';
        break;
      case 'soja':
      case 'soja_MT':
      case 'soja_PR':
      case 'soja_RS':
        result = 'Soja';
        break;
      case 'areaProdutiva':
        result = 'Soja';
        break;
      case 'renovaBio':
        result = 'RenovaBio';
        break;
      case 'status':
        result = 'Status Car';
        break;
      case 'area':
        result = 'Área';
        break;
      case 'bioma':
        result = 'Bioma';
        break;
      case 'icmBioInfractions':
        result = 'Auto de Infrações ICMBio';
        break;
      case 'ICMBio':
        result = 'ICMBio';
        break;
      case 'icmBioEmbargo':
        result = 'Embargo ICMBio';
        break;
      case 'cndt':
        result = 'Certidão Negativa de Débitos Trabalhistas';
        break;
      case 'company':
        result = 'Verificação status empresa';
        break;
      case 'LAR':
        result = 'LAR Pará';
        break;
      case 'Embargo SIGA':
        result = 'Embargo Siga';
        break;
      case 'Embargo Sema':
        result = 'Embargo Sema';
        break;
      case 'EMBARGO SIGA':
        result = 'Embargo Siga';
        break;
      case 'EMBARGO SEMA':
        result = 'Embargo Sema';
        break;
      case 'embargoSemaLista':
        result = 'Embargo Sema Lista';
        break;
      case 'IcmBioLista':
      case 'icmBioLista':
        result = 'ICMBio Lista';
        break;
      case 'alertasDeDesmatamentoIntegrados':
        result = 'Alertas de Desmatamento Integrados';
        break;
      case 'alertasDeDesmatamentoRadd':
        result = 'Alertas de Desmatamento RADD';
        break;
      case 'perdaDeCoberturaArborea':
        result = 'Perda de Cobertura Arbórea';
        break;
      case 'corpoHidricoArgentina':
        result = 'Corpos Hídricos (Argentina)';
        break;
      case 'terrasIndigenasArgentina':
        result = 'Terras Indígenas (Argentina)';
        break;
      case 'ramsarArgentina':
        result = 'Sítios Ramsar (Argentina)';
        break;
      case 'otbnArgentina':
        result = 'OTBN (Ordenamento Territorial de Bosques Nativos - Argentina)';
        break;
      case 'vegetacaoNativaArgentina':
        result = 'Vegetação Nativa (Argentina)';
        break;
      case 'ibasArgentina':
        result = 'IBAs - Áreas Importantes para Aves (Argentina)';
        break;
      case 'altaBiodiversidadeArgentina':
        result = 'Áreas de Alta Biodiversidade (Argentina)';
        break;
      case 'centroide':
        result = 'Centroide';
        break;
      case 'desmatamento':
        result = 'Desmatamento';
        break;
      case 'legalReserve':
        result = 'Reserva Legal';
        break;
      default:
        result = type;
        break;
    }

    return result;
  }

  getProtocols(options: { name?: any, date?: any, page?: any, size?: any }, modalResquest?: boolean) {
    let params = new HttpParams();

    if (options.name) {
      params = params.set('name', options.name);
    }

    if (options.date) {
      params = params.set('createdAt', options.date);
    }

    if (options.page) {
      params = params.set('page', options.page);
    }

    if (options.size) {
      params = params.set('size', options.size);
    }

    if (modalResquest)
      params = params.set('onlyActive', true);
    else
      params = params.set('onlyActive', false);

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      params,
    };

    return this.http.get(`${environment.api}/protocol-service/list/filtered/${this.customerId}`, httpOptions);
  }

  getProtocolsByProvider(options: { name?: any, date?: any, page?: any, size?: any }, customerId: any) {
    let params = new HttpParams();

    if (options.name) {
      params = params.set('name', options.name);
    }

    if (options.date) {
      params = params.set('createdAt', options.date);
    }

    if (options.page) {
      params = params.set('page', options.page);
    }

    if (options.size) {
      params = params.set('size', options.size);
    }

    params = params.set('onlyActive', false);

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      params,
    };

    return this.http.get(`${environment.api}/protocol-service/list/filtered/${customerId}`, httpOptions);
  }

  getProtocolByHash(hash?: any) {
    let params = new HttpParams();

    params = params.set('onlyActive', false);

    if (hash) {
      params = params.set('id', hash);
    }

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      params,
    };

    return this.http.get(`${environment.api}/protocol-service/list/filtered/${this.customerId}`, httpOptions);
  }

  getProtocolByHashByProvider(hash?: any, customerId?: any) {
    let params = new HttpParams();

    params = params.set('onlyActive', false);

    if (hash) {
      params = params.set('id', hash);
    }

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      params,
    };

    return this.http.get(`${environment.api}/protocol-service/list/filtered/${customerId}`, httpOptions);
  }

  getCriterias(criteriaCode?: any) {
    let params = new HttpParams();

    if (criteriaCode) {
      params = params.set('criteriaCode', criteriaCode);
    }

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      params
    };

    return this.http.get(`${environment.api}/criteria-service/list/filtered`, httpOptions);
  }

  inactivateProtocol(id: any) {
    let params = new HttpParams();

    if (id) {
      params = params.set('id', id);
    }

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      params
    };

    return this.http.get(`${environment.api}/protocol-service/inactivate-protocol`, httpOptions);
  }

  activateProtocol(id: any) {
    let params = new HttpParams();

    if (id) {
      params = params.set('id', id);
    }

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      params
    };

    return this.http.get(`${environment.api}/protocol-service/activate-protocol`, httpOptions);
  }

  getProtocolsOnlyActive(options: { name?: any, date?: any, page?: any, size?: any }) {
    let params = new HttpParams();


    if (options.name) {
      params = params.set('name', options.name);
    }

    if (options.date) {
      params = params.set('createdAt', options.date);
    }

    if (options.page) {
      params = params.set('page', options.page);
    }

    if (options.size) {
      params = params.set('size', options.size);
    }

    params = params.set('onlyActive', true);



    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      params,
    };

    return this.http.get(`${environment.api}/protocol-service/list/filtered/${this.customerId}`, httpOptions);
  }

  registerProtocol(body: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      })
    };

    return this.http.post(`${environment.api}/protocol-service/register?creationToken=${this.customerId}`, body, httpOptions);
  }

  updateProtocol(body: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      })
    };

    return this.http.put(`${environment.api}/protocol-service/update?creationToken=${this.customerId}`, body, httpOptions);
  }

  showHistory(id: any) {
    let params = new HttpParams();

    params = params.set('id', id);

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      params
    };

    return this.http.get(`${environment.api}/protocol-service/protocol-history`, httpOptions);

  }

  public removeWhiteList(id: any, customerId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
    };

    let httpRequest: any = httpOptions;
    httpRequest.responseType = 'text';

    return this.http.get(`${environment.api}/protocol-service/remove-token-from-white-list/${customerId}?id=${id}`, httpRequest);
  }

  public addWhiteList(id: any, customerId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
    };

    let httpRequest: any = httpOptions;
    httpRequest.responseType = 'text';

    return this.http.get(`${environment.api}/protocol-service/add-token-to-white-list/${customerId}?id=${id}`, httpRequest);
  }

}
